<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">人脸检测与跟踪</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对视频流的YUV数据进行人脸检测、跟踪，调用该接口前必须成功调用SKFaceVideoTrackInit接口，该接口与Image人脸检测接口存在互斥，不可并行调用。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKFaceVideoTrackYUV(byte[] YUVData, 
final FaceDetectCallbackInterface FaceDetectCallback)
// 人脸检测结果回调接口
public interface FaceDetectCallbackInterface {
    void FaceDetectCallback (FaceStruct[] FaceStructs);
}
public FaceStruct[] SKFaceVideoTrackYUV(byte[] YUVData)</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">（1）YUVData：视频帧的YUV数据</p>
             <p class="doc_main_p">（2）FaceDetectCallback(FaceStruct[] FaceStructs): 人脸检测结果回调FaceStructs检测结果结构体数组</p>
        </p>
        <h3 class="doc_main_h3">返回值</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">//检测结果结构体
public class FaceStruct {
    public int FaceRX1; // 人脸矩形左上点X
    public int FaceRY1; // 人脸矩形左上点Y
    public int FaceRX2; // 人脸矩形右上点X
    public int FaceRY2; // 人脸矩形右上点Y
    public int FaceRX3; // 人脸矩形右下点X
    public int FaceRY3; // 人脸矩形右下点Y
    public int FaceRX4; // 人脸矩形左下点X
    public int FaceRY4; // 人脸矩形左下点Y
    public int FaceRectSX; // 人脸正方形起始X
    public int FaceRectSY; // 人脸正方形起始Y
    public int FaceSize; // 人脸正方形边长
    public int TrackID; // 人脸跟踪ID[随机值主要使用于跟踪标记]
    public float ImageQuality; // 人脸图像品质0.0-1.0f  >0.7 进行人脸特征提取有效
    public int Update; // 人脸图像可识别更新情况 , 主要用于人脸跟踪. 0 不建议更新  1 建议更新
    public int Pitch;  // 抬头低头欧拉角(-90  -  90)  -30 - 30 度范围进行人脸特征提取有效
    public int Roll; // 面内旋转欧拉角(-180 - 180)   360全角度进行人脸特征提取有效
    public int Yaw; // 左右转动欧拉角(-90  -  90)  -45 - 45度范围进行人脸特征提取有效
    public int FaceDistance;//人脸距离（<0则表示无效（未检测到距离））
    public String PersonID; // 人员ID
    public String Name;//姓名
    public int Age; // 年龄 <=0 表示不清楚
    public int Sex; // 性别 0 不清楚 1 女性 2 男性
    public int Glasses; // 0 不戴眼镜 1 戴眼镜 2 太阳镜 <0 表示不清楚
    public String Feature;//人脸特征值
    public float KeyPoint[];  // 人脸形状关键点信息72个关键点，先x后y【企业版提供】
}</code></pre>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">skFace.SKFaceVideoTrackYUV(data, 
        new FaceDetectCallbackInterface() {
            @Override
            public void FaceDetectCallback(FaceStruct[] FaceStructs) {
                // TODO:此处FaceStructs即是识别结果的返回值，请勿在方法内做任何耗时操作
            }
        });
FaceStruct[] FaceStructs = skFace.SKFaceVideoTrackYUV(data);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import TestResultStructure from '../../../../components/testResultStructure.vue';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'test-result-rtructure':TestResultStructure
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Android','视频接口','人脸检测与跟踪'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdklive/voideinitiali/VoideDetection.vue